import { render, staticRenderFns } from "./BaseLabelWithFreightService.vue?vue&type=template&id=2abcf3cc&scoped=true&"
import script from "./BaseLabelWithFreightService.vue?vue&type=script&lang=js&"
export * from "./BaseLabelWithFreightService.vue?vue&type=script&lang=js&"
import style0 from "./BaseLabelWithFreightService.vue?vue&type=style&index=0&id=2abcf3cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abcf3cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
